var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m22 1.153 13.32 7.69a4 4 0 0 1 2 3.464V27.69a4 4 0 0 1-2 3.464L22 38.843a4 4 0 0 1-4 0l-13.32-7.69a4 4 0 0 1-2-3.464V12.307a4 4 0 0 1 2-3.464L18 1.153a4 4 0 0 1 4 0Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.91 16.857v-1.989h5.751V12h-15.32v2.868h5.75v1.989c-4.039.214-7.068 1.086-7.091 2.132v2.182c.023 1.046 3.052 1.919 7.091 2.132v4.882h3.818v-4.882c4.039-.212 7.068-1.086 7.091-2.132v-2.182c-.023-1.046-3.052-1.918-7.091-2.132h.002ZM20 21.803c-4.31 0-7.912-.737-8.793-1.724.748-.835 3.451-1.493 6.886-1.675v2.084a37.401 37.401 0 0 0 3.82 0v-2.084c3.432.18 6.137.84 6.884 1.675-.882.987-4.484 1.724-8.794 1.724H20Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 3,
    y1: 5.5,
    x2: 31,
    y2: 36.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A5A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.6dd0ca3c7b57350a5083aaf632f6aaad.svg";
export { ForwardRef as ReactComponent };